import { render, staticRenderFns } from "./fileItem.vue?vue&type=template&id=39bf6fed"
import script from "./fileItem.js?vue&type=script&lang=js&external"
export * from "./fileItem.js?vue&type=script&lang=js&external"
import style0 from "./fileItem.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports